/*
  CUSTOM PRODUCT PAGE — assets/custom-product.js
  Palo Alto theme compatible
*/

document.addEventListener('DOMContentLoaded', function () {

  // ══════════════════════════════════════════
  // HELPERS
  // ══════════════════════════════════════════

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function showToast(msg) {
    var t = document.getElementById('cpToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function () { t.classList.remove('show'); }, 2800);
  }

  // ══════════════════════════════════════════
  // 1. PRODUCT DATA + VARIANT STATE
  // ══════════════════════════════════════════

  var productDataEl = document.getElementById('cpProductData');
  var variants = [];
  if (productDataEl) {
    try { variants = JSON.parse(productDataEl.textContent).variants; } catch (e) {}
  }

  var currentVariant = variants[0] || null;
  var qty = 1;

  var variantInput  = document.getElementById('cpVariantId');
  var priceEl       = document.getElementById('cpPrice');
  var compareEl     = document.getElementById('cpComparePrice');
  var saveEl        = document.getElementById('cpPriceSave');
  var stockDot      = document.getElementById('cpStockDot');
  var stockText     = document.getElementById('cpStockText');
  var btnAtc        = document.getElementById('cpBtnAtc');
  var qnumEl        = document.getElementById('cpQnum');
  var shipFill      = document.getElementById('cpShipFill');
  var shipMsgText   = document.getElementById('cpShipMsg');
  var shipWrap      = document.getElementById('cpShipBar');
  var threshold     = shipWrap ? (parseInt(shipWrap.dataset.threshold, 10) || 10000) : 10000;

  function updateVariantUI(variant) {
    if (!variant) return;
    currentVariant = variant;
    if (variantInput) variantInput.value = variant.id;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
        if (saveEl) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
    }

    var avail = variant.available;
    if (stockDot) { stockDot.className = 'cp-stock-dot' + (avail ? '' : ' low'); }
    if (stockText) {
      if (!avail) {
        stockText.innerHTML = '<strong>Out of stock</strong>';
      } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
        stockText.innerHTML = 'Only <strong>' + variant.inventory_quantity + '</strong> left';
      } else {
        stockText.innerHTML = 'In stock';
      }
    }
    if (btnAtc) {
      btnAtc.disabled = !avail;
      btnAtc.textContent = avail ? 'Add to Cart' : 'Sold Out';
    }

    refreshShipBar(variant.price * qty);
    history.replaceState({}, '', '?variant=' + variant.id);
  }

  // ══════════════════════════════════════════
  // 2. VARIANT SWITCHING
  // ══════════════════════════════════════════

  // Color swatches
  document.querySelectorAll('.cp-swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var val = sw.dataset.value;
      var optIndex = parseInt(sw.dataset.optionIndex, 10);
      document.querySelectorAll('.cp-swatch[data-option-index="' + optIndex + '"]').forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      matchVariant();
    });
  });

  // Size buttons
  document.querySelectorAll('.cp-sz').forEach(function (btn) {
    if (btn.classList.contains('oos')) return;
    btn.addEventListener('click', function () {
      var optIndex = parseInt(btn.dataset.optionIndex, 10);
      document.querySelectorAll('.cp-sz[data-option-index="' + optIndex + '"]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      matchVariant();
    });
  });

  function getSelectedOptions() {
    var opts = {};
    document.querySelectorAll('.cp-swatch.active, .cp-sz.active').forEach(function (el) {
      opts[parseInt(el.dataset.optionIndex, 10)] = el.dataset.value;
    });
    return opts;
  }

  function matchVariant() {
    var selected = getSelectedOptions();
    var match = variants.find(function (v) {
      return Object.keys(selected).every(function (i) {
        var prop = 'option' + (parseInt(i, 10) + 1);
        return v[prop] === selected[i];
      });
    });
    if (match) updateVariantUI(match);
  }

  if (currentVariant) updateVariantUI(currentVariant);

  // ══════════════════════════════════════════
  // 3. QUANTITY
  // ══════════════════════════════════════════

  var minusBtn = document.getElementById('cpQminus');
  var plusBtn  = document.getElementById('cpQplus');

  if (minusBtn) minusBtn.addEventListener('click', function () {
    if (qty > 1) { qty--; if (qnumEl) qnumEl.textContent = qty; if (currentVariant) refreshShipBar(currentVariant.price * qty); }
  });
  if (plusBtn) plusBtn.addEventListener('click', function () {
    qty++; if (qnumEl) qnumEl.textContent = qty; if (currentVariant) refreshShipBar(currentVariant.price * qty);
  });

  // ══════════════════════════════════════════
  // 4. ADD TO CART — native Palo Alto form
  // ══════════════════════════════════════════

  // Palo Alto's own product form — has data-product-form attribute.
  // We update its hidden inputs and dispatch a submit event so Palo Alto's
  // JS handles everything: cart drawer open, dot indicator, animations.
  var paloForm = document.querySelector('form[data-product-form]');
  var ourForm  = document.getElementById('cpProductForm');

  function doAddToCart(variantId, quantity) {
    if (!variantId) return;
    if (btnAtc) { btnAtc.textContent = 'Adding…'; btnAtc.disabled = true; }

    // Step 1: Add to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      // Step 2: Fetch /cart.json — this is what Palo Alto does to trigger drawer rebuild
      return fetch('/cart.json');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (btnAtc) {
        btnAtc.textContent = currentVariant && currentVariant.available ? 'Add to Cart' : 'Sold Out';
        btnAtc.disabled = !(currentVariant && currentVariant.available);
      }

      // Step 3: Update ship bar
      updateShipBar(cart.total_price);

      // Step 4: Update cart dot
      document.querySelectorAll('.cart__toggle').forEach(function(el) {
        el.classList.toggle('cart__toggle--has-items', cart.item_count > 0);
      });

      // Step 5: Fetch /cart.js — second call Palo Alto makes, triggers drawer re-render
      return fetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      // Step 6: Fetch fresh cart drawer HTML and swap it in, then open
      return fetch('/?sections=sections--24447384125604__header');
    })
    .then(function(r) { return r.json(); })
    .then(function(sections) {
      // Swap the cart drawer body with fresh HTML
      var sectionKey = Object.keys(sections)[0];
      if (sectionKey) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(sections[sectionKey], 'text/html');
        // Swap just the cart drawer body contents
        var newBody = doc.querySelector('[data-cart-drawer-body]');
        var curBody = document.querySelector('[data-cart-drawer-body]');
        if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
        // Update item count
        var newQty = doc.querySelector('[data-cart-items-qty]');
        var curQty = document.querySelector('[data-cart-items-qty]');
        if (newQty && curQty) { curQty.textContent = newQty.textContent; curQty.classList.remove('hidden'); }
        // Update cart toggle dot
        var newToggle = doc.querySelector('.cart__toggle');
        var curToggle = document.querySelector('.cart__toggle');
        if (newToggle && curToggle) {
          if (newToggle.classList.contains('cart__toggle--has-items')) {
            curToggle.classList.add('cart__toggle--has-items');
          }
        }
      }
      // Open the drawer
      var cartToggle = document.querySelector('.cart__toggle');
      if (cartToggle) cartToggle.click();
    })
    .catch(function() {
      if (btnAtc) { btnAtc.textContent = 'Add to Cart'; btnAtc.disabled = false; }
      showToast('Something went wrong.');
    });
  }

  if (ourForm) {
    ourForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!currentVariant) return;
      doAddToCart(currentVariant.id, qty);
    });
  }

  // ══════════════════════════════════════════
  // 5. CART DOT
  // ══════════════════════════════════════════

  function updateCartDot() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Palo Alto shows dot by adding cart__toggle--has-items
        document.querySelectorAll('.cart__toggle').forEach(function (el) {
          el.classList.toggle('cart__toggle--has-items', cart.item_count > 0);
        });
      })
      .catch(function () {});
  }

  // ══════════════════════════════════════════
  // 6. FREE SHIPPING BAR
  // ══════════════════════════════════════════

  function refreshShipBar(itemCents) {
    if (!shipWrap || !shipFill || !shipMsgText) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price + itemCents;
        updateShipBar(total);
      })
      .catch(function () { updateShipBar(itemCents); });
  }

  function updateShipBar(totalCents) {
    if (!shipFill || !shipMsgText) return;
    var needed = Math.max(0, threshold - totalCents);
    var pct    = Math.min(100, (totalCents / threshold) * 100);
    shipFill.style.width = pct.toFixed(1) + '%';
    if (needed === 0) {
      shipFill.classList.add('complete');
      shipMsgText.innerHTML = '🎉 <em>You\'ve unlocked free shipping!</em>';
    } else {
      shipFill.classList.remove('complete');
      shipMsgText.innerHTML = 'You\'re <em>' + formatMoney(needed) + '</em> away from free shipping';
    }
  }

  function fetchAndUpdateShipBar() {
    if (!shipWrap) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { updateShipBar(cart.total_price); }).catch(function () {});
  }

  if (shipWrap) fetchAndUpdateShipBar();

  // ══════════════════════════════════════════
  // 7. SHOW MORE / SHOW LESS
  // ══════════════════════════════════════════

  var smBtn   = document.getElementById('cpShowMoreBtn');
  var smLabel = document.getElementById('cpShowMoreLabel');
  var extraEl = document.getElementById('cpExtraImgs');

  if (smBtn && extraEl) {
    smBtn.addEventListener('click', function () {
      var isOpen = extraEl.classList.contains('open');
      extraEl.classList.toggle('open', !isOpen);
      smBtn.classList.toggle('open', !isOpen);
      if (smLabel) smLabel.textContent = isOpen ? 'Show more' : 'Show less';
      smBtn.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  // ══════════════════════════════════════════
  // 8. ACCORDION
  // ══════════════════════════════════════════

  window.cpToggleAcc = function (btn) {
    var body  = btn.nextElementSibling;
    var arrow = btn.querySelector('.cp-acc-arrow');
    var isOpen = body.classList.contains('open');
    body.classList.toggle('open', !isOpen);
    if (arrow) arrow.classList.toggle('open', !isOpen);
    btn.setAttribute('aria-expanded', String(!isOpen));
  };

  // ══════════════════════════════════════════
  // 9. COMPLETE THE LOOK
  // ══════════════════════════════════════════

  var lookPanel  = document.getElementById('cpLookPanel');
  var lookPairs  = document.getElementById('cpLookPairs');
  var lookAddBtn = document.getElementById('cpLookAddBtn');
  var lookTotal  = document.getElementById('cpLookTotal');

  function getLookRows() { return document.querySelectorAll('#cpLookPairs .cp-look-row--check'); }

  function calcLookTotal() {
    if (!lookAddBtn) return;
    var base = parseInt(lookAddBtn.dataset.basePrice, 10) || 0;
    var total = base;
    var count = 0;
    getLookRows().forEach(function (row) {
      if (!row.classList.contains('unchecked')) {
        total += parseInt(row.dataset.price, 10) || 0;
        count++;
      }
    });
    if (lookTotal) lookTotal.textContent = formatMoney(total);
    lookAddBtn.textContent = 'Add ' + (count + 1) + ' items to cart';
  }

  window.cpInitLookRows = function () {
    getLookRows().forEach(function (row) {
      row.addEventListener('click', function () {
        var cb = row.querySelector('.cp-look-cb');
        var unchecked = row.classList.contains('unchecked');
        row.classList.toggle('unchecked', !unchecked);
        if (cb) cb.classList.toggle('checked', !unchecked);
        calcLookTotal();
      });
    });
    calcLookTotal();
  };

  if (lookAddBtn) {
    lookAddBtn.addEventListener('click', function () {
      var baseId = lookAddBtn.dataset.variantId;
      if (!baseId) return;
      var items = [{ id: parseInt(baseId, 10), quantity: qty }];
      getLookRows().forEach(function (row) {
        if (!row.classList.contains('unchecked')) {
          var vid = row.dataset.variant;
          if (vid) items.push({ id: parseInt(vid, 10), quantity: 1 });
        }
      });
      lookAddBtn.textContent = 'Adding…';
      lookAddBtn.disabled = true;

      if (paloForm && items.length === 1) {
        // Single item — use native Palo Alto form
        doAddToCart(items[0].id, items[0].quantity);
        setTimeout(function () { lookAddBtn.disabled = false; calcLookTotal(); }, 1200);
      } else {
        // Multiple items — AJAX batch
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          lookAddBtn.disabled = false;
          calcLookTotal();
          showToast('Added to cart ✓');
          fetchAndUpdateShipBar();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          lookAddBtn.disabled = false;
          calcLookTotal();
          showToast('Something went wrong.');
        });
      }
    });
  }

  if (lookPanel) {
    var collHandle = lookPanel.dataset.collection;
    var curId      = lookPanel.dataset.productId;
    var offset     = lookPanel.dataset.offset || 0;

    if (collHandle && lookPairs) {
      fetch('/collections/' + collHandle + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var all = (data.products || []).filter(function (p) {
            return String(p.id) !== String(curId) && p.available;
          });
          if (!all.length) { lookPairs.innerHTML = ''; return; }
          var start   = parseInt(offset, 10) % all.length;
          var rotated = all.slice(start).concat(all.slice(0, start));
          var picks   = rotated.slice(0, 3);

          lookPairs.innerHTML = picks.map(function (p) {
            var v     = p.variants && p.variants[0];
            if (!v) return '';
            var img   = p.images && p.images[0] ? '<img src="' + p.images[0].src + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '';
            var price = v.price ? formatMoney(Math.round(parseFloat(v.price) * 100)) : '';
            var cents = v.price ? Math.round(parseFloat(v.price) * 100) : 0;
            return '<div class="cp-look-row cp-look-row--check" data-variant="' + v.id + '" data-price="' + cents + '">'
              + '<div class="cp-look-cb checked">✓</div>'
              + '<div class="cp-look-thumb">' + img + '</div>'
              + '<div class="cp-look-info"><div class="cp-look-name">' + p.title + '</div><div class="cp-look-price">' + price + '</div></div>'
              + '</div>';
          }).join('');

          window.cpInitLookRows();
        })
        .catch(function () { if (lookPairs) lookPairs.innerHTML = ''; });
    }
  }

}); // end DOMContentLoaded
